// Single source of truth for role -> color, used by project cards, rosters,
// and the planner so a Project Accountant never looks like a Superintendent.
// Order matters: more specific roles are listed before broader ones
// (e.g. APM before PM, Sr. Supt before Supt, QA/QC before Engineer).
// Lighter, cleaner tones — easy on the eyes while still readable with white initials.

// `match` entries are regexes tested against the lowercased role. Short codes
// (PM, PE, FE, PX…) use word boundaries so they can't fire inside longer words
// ("car-PE-nter", "ex-PE-ditor" used to be colored as Engineers).
export const ROLE_COLORS = [
  { label: "PX", color: "#8b5cf6", match: [/\bpx\b/, /project executive/] },          // violet
  { label: "Sr. PM", color: "#3b82f6", match: [/sr\.?\s*pm\b/, /senior project manager/] }, // blue
  { label: "APM", color: "#22c1d6", match: [/\bapm\b/, /assistant project manager/] }, // cyan
  { label: "PM", color: "#60a5fa", match: [/\bpm\b/, /project manager/] },             // light blue
  { label: "Sr. Supt", color: "#e08e2f", match: [/sr\.?\s*supt/, /gen\.?\s*supt/, /general superintendent/, /senior superintendent/] }, // amber
  { label: "Finish Supt", color: "#f6c453", match: [/finish\s*supt/] },              // light gold
  { label: "Asst. Supt", color: "#eab308", match: [/asst\.?\s*supt/, /assistant superintendent/] }, // gold
  { label: "Supt", color: "#f59e0b", match: [/supt/, /superintendent/] },          // amber-gold
  { label: "QA/QC", color: "#14b8a6", match: [/\bqa\b/, /\bqc\b/, /qa\/qc/, /quality/] },            // teal
  { label: "Engineer", color: "#34c77b", match: [/\bpe\b/, /\bfe\b/, /engineer/] },        // green
  { label: "Accountant", color: "#94a3b8", match: [/accountant/] },                // slate
];

const DEFAULT_COLOR = "#7c8694";

export function roleColor(role) {
  const r = (role || "").toLowerCase();
  for (const rc of ROLE_COLORS) {
    if (rc.match.some((m) => m.test(r))) return rc.color;
  }
  return DEFAULT_COLOR;
}